import ApiConstants from "../constants/ApiConstants";
import http from "../http";
import { Subject } from "rxjs";

class RootInterceptorService {
    static EVALUATED = false;

    static workdayLogin(payload) {
        return http.post(ApiConstants.URL.WORKDAY.SIGN_IN, payload).catch(
            (error) => {
                console.error('Error in workday sign in: ', error);
                return Promise.reject(error);
            }
        );
    }
}

const subject = new Subject();
export const RootInterceptorObservable = {
    sendMessage: message => subject.next(message),
    clearMessages: () => subject.next({}),
    getMessage: () => subject.asObservable()
};

export default RootInterceptorService;
